// 藥物資訊查詢 component

<template>
  <div>
    <div class="upper-subpanel row">
      <progressbar/>
      <div class="upper-subpanel--without-progressbar">
        <drugSelection/>
        <drugInfoWeb v-if="showWeb" v-on:closetab="closetab"/>
      </div>
    </div>


    <bottom-buttons>
      <action-button slot="button-1" title="回主畫面" @click.native="cancel"/>
    </bottom-buttons>
  </div>
</template>

<script>
import progressbar from './flowComp/ProgressBar';
import drugSelection from './flowComp/DrugSelection';
import drugInfoWeb from './flowComp/DrugInfoWeb';
import BottomButtons from './common/BottomButtons';

export default {
  name: 'DrugInfo',
  data() {
    return {
      showWeb: false,
      progress: [
        {
          en: 'selectDrug',
          zh: '選擇藥物',
        },
      ],
    };
  },
  components: {
    drugSelection,
    drugInfoWeb,
    progressbar,
    BottomButtons,
  },
  created() {
    this.$store.commit('SET_APP', '藥物資訊');
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    this.$store.commit('SET_PROGRESS', this.progress);
  },
  computed: {
    drug() {
      return this.$store.state.drug.selectedDrug;
    },
  },
  watch: {
    drug(val) {
      if (val !== '') {
        this.showWeb = true;
      } else {
        this.showWeb = false;
      }
    },
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'Main' });
    },
    closetab() {
      this.showWeb = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// DrugInfo.vue?3c74296e